import { useMemo } from "react";
import { attributeToTitle } from "src/utils/strings";

export function useCommonPrefixes(
  strings: string[][],
  spaced = false,
  noPrune = false
) {
  const common = useMemo(
    () => findCommonPrefixes(strings, spaced),
    [spaced, strings]
  );
  return useMemo(
    () => (noPrune ? new Set(common) : pruneCommonPrefixes(common)),
    [noPrune, common]
  );
}

export function findCommonPrefixes(
  words: string[][],
  spaced?: boolean
): string[] {
  const prefixes: string[] = [];
  for (let i = 0; i < words.length - 1; i++) {
    const words1 = words[i];
    for (let j = i + 1; j < words.length; j++) {
      const words2 = words[j];
      let prefix = "";
      for (let k = 0; k < Math.min(words1.length, words2.length); k++) {
        if (words1[k] !== words2[k]) break;
        prefix += (spaced ? " " : "") + words1[k];
      }
      if (prefix.length > 0) prefixes.push(prefix.trim());
    }
  }
  return [...new Set(prefixes)].sort();
}

export function pruneCommonPrefixes(prefixes: string[]) {
  const prefixSet = new Set(prefixes);
  let i, j;
  for (i = 0; i < prefixes.length; i += 1)
    for (j = i + 1; j < prefixes.length; j += 1) {
      if (prefixes[i].startsWith(prefixes[j])) prefixSet.delete(prefixes[i]);
      else if (prefixes[j].startsWith(prefixes[i]))
        prefixSet.delete(prefixes[j]);
    }
  return prefixSet;
}

export function wordify(strings: string[]): string[][] {
  return strings.map((str) => {
    const words = attributeToTitle(str);
    return `${str.at(0)}${words.slice(1)}`.split(" ").filter(Boolean);
  });
}
